import { render, staticRenderFns } from "./discountorderitem.vue?vue&type=template&id=0e9a914e&scoped=true"
import script from "./discountorderitem.vue?vue&type=script&lang=js"
export * from "./discountorderitem.vue?vue&type=script&lang=js"
import style0 from "./discountorderitem.vue?vue&type=style&index=0&id=0e9a914e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a914e",
  null
  
)

export default component.exports